module.exports = __webpack_public_path__ + "img/bg@2x.549ef37e.png";